<template>
	<div class="wrapper form">
		<div class="input-wrapper">
			<div class="input__title">Kockázatviselési cím:</div>
			<InputField :elements="fields.riskBearingAddress" />
		</div>
		<div class="input-wrapper">
			<div class="input__title">Szerződő adatai:</div>
			<InputField :elements="fields.contractDetails" />
		</div>
		<div
			class="input-wrapper inline mb-20px"
			style="background-color: #f4f5f4"
			v-if="getCalculation.payment_method === 2"
		>
			<div class="input__title">Fizetési adatok:</div>
			<InputField :elements="fields.paymentDetails" />
		</div>
		<div class="input-wrapper no-p-top">
			<CalcElem
				name="differentPermanentAddress"
				:options="{
					label: 'A szerződő állandó lakcíme eltér a kockázatviselési címtől',
					type: 'checkbox',
					wrapperClass: 'col-w100-chbox chbox_style-wrapper',
					className: 'mw-500px',
					prop: 'differentPermanentAddress',
				}"
				type="contracting"
				class="checkbox-center"
			/>
		</div>
		<div
			class="input-wrapper mb-20px"
			style="background-color: #f4f5f4"
			v-if="getCheckboxData('differentPermanentAddress')"
		>
			<div class="input__title">Szerződő állandó lakcíme:</div>
			<InputField :elements="fields.permanentAddress" refGroup="baseData-permanentAddress" />
		</div>
		<div class="input-wrapper no-p-top">
			<CalcElem
				name="differentMailingAddress"
				:options="{
					label: 'A szerződő levelezési címe eltér az állandótól',
					type: 'checkbox',
					wrapperClass: 'col-w100-chbox chbox_style-wrapper',
					className: 'mw-500px',
					prop: 'differentMailingAddress',
				}"
				type="contracting"
				class="checkbox-center"
			/>
		</div>
		<div
			class="input-wrapper mb-20px"
			style="background-color: #f4f5f4"
			v-if="getCheckboxData('differentMailingAddress')"
		>
			<div class="input__title">Szerződő levelezési címe:</div>
			<InputField :elements="fields.mailingAddress" refGroup="baseData-mailingAddress" />
		</div>
		<div class="input-wrapper no-p-top">
			<CalcElem
				name="differentInsuredData"
				:options="{
					label: 'A biztosított adatai eltérnek a fentiektől',
					type: 'checkbox',
					wrapperClass: 'col-w100-chbox chbox_style-wrapper',
					className: 'mw-500px',
					prop: 'differentInsuredData',
				}"
				type="contracting"
				class="checkbox-center"
			/>
		</div>
		<div class="input-wrapper mb-20px">
			<div class="input__title">Kedvezményre jogosító adatok:</div>
			<div class="input__field discounts">
				<CalcElem
					name="kobeMember"
					:options="{
						label: 'KÖBE tag vagyok',
						type: 'checkbox',
						wrapperClass: 'col-w100-chbox chbox_style-wrapper',
						inputClass: 'w-100 mobile-width-full d-flex items-center justify-center',
						className: 'mw-500px',
						prop: 'kobeMember',
					}"
					type="contracting"
					class="checkbox-center"
				/>
				<div class="w-100 d-flex mt-20px flex-m-column" v-if="getCheckboxData('kobeMember')">
					<CalcElem
						v-for="(field, fIndex) in fields.discounts"
						:key="fIndex"
						:options="field"
						type="contracting"
						:class="field.inputClass"
						:name="fIndex"
					/>
				</div>
			</div>
		</div>
		<div class="input-wrapper mb-20px" style="background-color: #f4f5f4" v-if="hasBeneficiaries">
			<div class="input__title">
				Balesetbiztosítás kedvezményezett adatai:
				<br />
				<div class="info">
					Kérjük, adja meg a kedvezményezettek adatait.
					<br />
					A balesetbiztosítási események kedvezményezettje maga a Biztosított, a Biztosított baleseti halála
					esetén az általa megjelölt kedvezményezett(ek),
					<br />
					ennek hiányában a Biztosított törvényes örököse.
				</div>
			</div>
			<div class="input__field" :class="{ 'mt-30px': index !== 1 }" v-for="index in beneficiaries" :key="index">
				<CalcElem
					v-for="(field, fIndex) in comutedBeneficiaryFields(index)"
					:key="fIndex"
					:options="field"
					type="contracting"
					:class="field.inputClass"
					:index="index"
					:name="fIndex"
					:ref="`baseData-beneficiaryData-${index}-${fIndex}`"
				/>
				<div class="rows w-100 mt-12px" v-if="index !== 1">
					<div class="input__delete text-center" @click="handleDelete(index)">Eltávolítás</div>
				</div>
			</div>
			<div class="input__more" @click="handleAddBenediciaries" v-if="beneficiaries.length < 5">
				<span>További kedvezményezett hozzáadása</span>
			</div>
		</div>
	</div>
</template>

<script>
import _ from 'lodash';
import dataPages from '@/mixins/dataPages';
import baseData from '@/mixins/baseData';
import beneficiary from '@/mixins/beneficiary';

export default {
	mixins: [dataPages, baseData, beneficiary],
	data() {
		return {
			insurer: 'kobe',
			type: 'baseData',
		};
	},
};
</script>
